<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="col p-3 border-bottom" >
                <template #default>افزودن آگهی   </template>
                </m-h3></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container-fluid " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-md-3 col-sm-6 col-6" >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":12,"itemType":"product","iconName":""},...{}}' :style='"border-radius:15px;"' class="p-3 text-center border  bg-white m-1" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.geramyan.com\/storage\/123\/truck.png","alt":"mix it web"},...{}}' :style='""' class="col-6 " ></m-img><m-h2 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>صاحب بار   </template>
                </m-h2><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ثبت آگهی صاحب بار برای دریافت تماس از راننده   </template>
                </m-p><m-h3 v-bind='{...{},...{}}' :style='""' class="btn btn-primary text-white" >
                <template #default>+ افزودن   </template>
                </m-h3></template>
                </m-div></template>
                </m-copy-1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-md-3 col-sm-6 col-6 d-none" >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":21,"itemType":"product","iconName":""},...{}}' :style='"border-radius:15px;"' class="p-3 text-center border  bg-white m-1" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.geramyan.com\/storage\/categories\/R0rNc5HsvH8vs0MFLWv2wPuudLK7FtIGYvMOHpjM.png","alt":"mix it web"},...{}}' :style='""' class="col-6 " ></m-img><m-h2 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>کامیون دار   </template>
                </m-h2><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ثبت آگهی کامیون دار  و  راننده پایه یک   </template>
                </m-p><m-h3 v-bind='{...{},...{}}' :style='""' class="btn btn-primary  text-white" >
                <template #default>+ افزودن   </template>
                </m-h3></template>
                </m-div></template>
                </m-copy-1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-md-3 col-sm-6 col-6 d-none" >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":19,"itemType":"product","iconName":""},...{}}' :style='"border-radius:15px;"' class="p-3 text-center border  bg-white m-1" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.geramyan.com\/storage\/categories\/lDGugMg93SuLx8lQ9QRfBbhONySkUXBsLmOHamd8.png","alt":"mix it web"},...{}}' :style='""' class="col-6 " ></m-img><m-h2 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>کشاورز   </template>
                </m-h2><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>متن نمونه   </template>
                </m-p><m-h3 v-bind='{...{},...{}}' :style='""' class="btn btn-primary text-white" >
                <template #default>+ افزودن   </template>
                </m-h3></template>
                </m-div></template>
                </m-copy-1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-md-3 col-sm-6 col-6 d-none" >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":20,"itemType":"product","iconName":""},...{}}' :style='"border-radius:15px;"' class="p-3 text-center border  bg-white m-1" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.geramyan.com\/storage\/bargiri\/geramyan.JPG","alt":"mix it web"},...{}}' :style='""' class="col-6 " ></m-img><m-h2 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>صاحبان شناور   </template>
                </m-h2><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>کشتی باری لنج لندیگراف برای نوبت دهی بوکینگ   </template>
                </m-p><m-h3 v-bind='{...{},...{}}' :style='""' class="btn btn-primary text-white" >
                <template #default>+ افزودن   </template>
                </m-h3></template>
                </m-div></template>
                </m-div></template>
                </m-copy-1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-md-3 col-sm-6 col-6 d-none" >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":22,"itemType":"product","iconName":""},...{}}' :style='"border-radius:15px;"' class="p-3 text-center border  bg-white m-1" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.geramyan.com\/storage\/categories\/vkhHZMu61idOqVXuVXq9RncNF6JWcLH8qlKAlnSx.png","alt":"mix it web"},...{}}' :style='""' class="col-6 " ></m-img><m-h2 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>آگهی باربری برای صدور بارنامه   </template>
                </m-h2><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>برای دریافت (سفارش بارنامه) از رانندگان   </template>
                </m-p><m-h3 v-bind='{...{},...{}}' :style='""' class="btn btn-primary  text-white" >
                <template #default>+ افزودن   </template>
                </m-h3></template>
                </m-div></template>
                </m-copy-1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-md-3 col-sm-6 col-6 d-none" >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":23,"itemType":"product","iconName":""},...{}}' :style='"border-radius:15px;"' class="text-center border  bg-white m-1 p-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.geramyan.com\/storage\/categories\/LH0JMM2nGylfBVcdDQnfyU28E9rpcB2mqvVdcnI3.png","alt":"mix it web"},...{}}' :style='""' class="col-6 " ></m-img><m-h2 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>آگهی شرکتهای بیمه حمل و نقل   </template>
                </m-h2><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>برای دریافت سفارش بیمه بار از صاحبان بار و رانندگان   </template>
                </m-p><m-h3 v-bind='{...{},...{}}' :style='""' class="btn btn-primary text-white" >
                <template #default>+ افزودن   </template>
                </m-h3></template>
                </m-div></template>
                </m-copy-1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-2 col-md-3 col-sm-6 col-6 d-none" >
                <template #default>   <m-copy-1 v-bind='{...{"itemId":504,"itemType":"product","iconName":""},...{}}' :style='"border-radius:15px;"' class="text-center border  bg-white m-1 p-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.geramyan.com\/storage\/categories\/LH0JMM2nGylfBVcdDQnfyU28E9rpcB2mqvVdcnI3.png","alt":"mix it web"},...{}}' :style='""' class="col-6 " ></m-img><m-h2 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>آگهی هواپیما   </template>
                </m-h2><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>برای   </template>
                </m-p><m-h3 v-bind='{...{},...{}}' :style='""' class="btn btn-primary text-white" >
                <template #default>+ افزودن   </template>
                </m-h3></template>
                </m-div></template>
                </m-copy-1></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mCopy1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Copy/Copy1'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH3,mCopy1,mImg,mH2,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
